import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';
import {
	NgbAccordionButton,
	NgbAccordionDirective,
	NgbAccordionItem,
	NgbAccordionHeader,
	NgbAccordionToggle,
	NgbAccordionBody,
	NgbAccordionCollapse,
} from '@ng-bootstrap/ng-bootstrap/accordion';

@Component({
  selector: 'app-article-with-collapsible-panels',
  standalone: true,
  imports: [
    CommonModule, 
    BypassSecurityPipe,
  NgbAccordionButton,
	NgbAccordionDirective,
	NgbAccordionItem,
	NgbAccordionHeader,
	NgbAccordionToggle,
	NgbAccordionBody,
	NgbAccordionCollapse,],
  templateUrl: './article-with-collapsible-panels.component.html',
  styleUrls: ['./article-with-collapsible-panels.component.less']
})
export class ArticleWithCollapsiblePanelsComponent {
  @Input() data: any;
}
